
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/powering",
      function () {
        return require("private-next-pages/powering/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/powering"])
      });
    }
  